let observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    let isAbove = (window.scrollY < document.querySelector('[data-observe-atc]').offsetTop);

    toggleButtonVisibility(entry.isIntersecting || isAbove);
  })
}, { threshold: 1 });

observer.observe(document.querySelector('[data-observe-atc]'));

function toggleButtonVisibility(isVisible) { 
  document.querySelector('[data-hide-atc-mobile]').classList.toggle('hidden', isVisible);
}

function scrollToTitle() {
  const productTitle = document.querySelector('[data-display-title]');
  if (productTitle) {
    let cookieBarHeight = document.querySelector('#becookiebarpanelid')?.offsetHeight;
    let headerHeight = 50;
    let headerOffset = cookieBarHeight + headerHeight;
    let titlePosition = productTitle.getBoundingClientRect().top;
    let offsetPosition = titlePosition + window.pageYOffset - headerOffset;
  
    window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
    });

    gtag('event', 'sticky_ATC_click', {
      event_category: 'experiments',
      event_action: 'stickyATC',
      value: 1
    });
  }
}

document.querySelector('[data-atc-scroll-mobile]')?.addEventListener('click', scrollToTitle);